import { isArray, isEmpty, indexOf, orderBy, find, max, sum, cloneDeep, filter, isNaN } from 'lodash';
import { blue, green, amber, blueGrey, red, brown, deepOrange, deepPurple } from 'material-colors';
import moment from 'moment';
import 'moment/locale/es';
import numeral from 'numeral';
import Immutable from 'immutable';
import Color from 'chartjs-color';

moment.locale('es');

// TODO Revisar fallos en moment (formato Año-Semana y Semana) (mcontreras)

export const chartColorPalette = [
    blue[300], green[300], amber[300], blueGrey[300], red[300], brown[300], deepOrange[300], deepPurple[300],
    blue[700], green[700], amber[700], blueGrey[700], red[700], brown[700], deepOrange[700], deepPurple[700]
];

export const chartFamilies = [
    {
        name: 'Lines',
        value: 'lines',
        icon: 'img/line-chart.png'
    }, {
        name: 'Areas',
        value: 'areas',
        icon: 'img/area-chart.png'
    }, {
        name: 'Bars',
        value: 'bars',
        icon: 'img/chart.png'
    }, {
        name: 'Pies',
        value: 'pies',
        icon: 'img/pie-chart.png'
    }, {
        name: 'Mixed',
        value: 'mixed',
        icon: 'img/mixed-chart.png'
    }
];

export const chartCatalog = [
    {
        label: 'Lines',
        value: 'line',
        type: 'line',
        family: 'lines',
        breakable: true,
        orientation: 'vertical',
        icon: 'img/line-chart.png',
        conditions: {
            dimension: { min: 1, max : 1 },
            metrics: { min: 1 },
            breaker: { max: 1 }
        }
    }, {
        label: 'Areas',
        value: 'area',
        type: 'line',
        family: 'areas',
        breakable: true,
        orientation: 'vertical',
        icon: 'img/area-chart.png',
        conditions: {
            dimension: { min: 1, max : 1 },
            metrics: { min: 1 },
            breaker: { max: 1 }
        }
    }, {
        label: 'Vertical Bars',
        value: 'bar',
        type: 'bar',
        family: 'bars',
        breakable: true,
        orientation: 'vertical',
        icon: 'img/chart.png',
        conditions: {
            dimension: { min: 1, max : 1 },
            metrics: { min: 1 },
            breaker: { max: 1 }
        }
    }, {
        label: 'Horizontal Bars',
        value: 'horizontalBar',
        type: 'horizontalBar',
        family: 'bars',
        breakable: true,
        orientation: 'horizontal',
        icon: 'img/horizontal-bar-chart.png',
        conditions: {
            dimension: { min: 1, max : 1 },
            metrics: { min: 1 },
            breaker: { max: 1 }
        }
    }, {
        label: 'Stacked Vertical Bars',
        value: 'stackedBar',
        type: 'bar',
        family: 'bars',
        orientation: 'vertical',
        breakable: true,
        icon: 'img/stacked-chart.png',
        conditions: {
            dimension: { min: 1, max : 1 },
            metrics: { min: 1, max: 1 },
            breaker: { min: 1 }
        }
    }, {
        label: 'Stacked Horizontal Bars',
        value: 'stackedHorizontalBar',
        type: 'horizontalBar',
        family: 'bars',
        breakable: true,
        orientation: 'horizontal',
        icon: 'img/stacked-horizontal-bar-chart.png',
        conditions: {
            dimension: { min: 1, max : 1 },
            metrics: { min: 1, max: 1 },
            breaker: { min: 1 }
        }
    }, {
        label: 'Mixes Lines/Bars',
        value: 'mixed',
        type: 'bar',
        family: 'mixed',
        breakable: false,
        orientation: 'vertical',
        icon: 'img/mixed-chart.png',
        conditions: {
            dimension: { min: 1, max : 1 },
            metrics: { min: 1 },
            breaker: { max: 0 }
        }
    }, {
        label: 'Donut',
        value: 'doughnut',
        type: 'doughnut',
        family: 'pies',
        breakable: false,
        orientation: 'vertical',
        icon: 'img/doughnut-chart.png',
        conditions: {
            dimension: { min: 1, max : 1 },
            metrics: { min: 1, max: 1 },
            breaker: { max: 0 }
        }
    }, {
        label: 'Pie',
        value: 'pie',
        type: 'pie',
        family: 'pies',
        breakable: false,
        orientation: 'vertical',
        icon: 'img/pie-chart.png',
        conditions: {
            dimension: { min: 1, max : 1 },
            metrics: { min: 1, max: 1 },
            breaker: { max: 0 }
        }
    }, {
        label: 'Radar',
        value: 'radar',
        type: 'radar',
        family: 'pies',
        breakable: true,
        orientation: 'vertical',
        icon: 'img/radar-chart.png',
        conditions: {
            dimension: { min: 1, max : 1 },
            metrics: { min: 1 },
            breaker: { max: 0 }
        }
    }
];

export const ticksDirection = [
    {
        label: 'Automático',
        value: ''
    }, {
        label: 'Horizontal',
        value: 'horizontal'
    }, {
        label: 'Vertical',
        value: 'vertical'
    }, {
        label: 'Inclinado',
        value: 'slanting'
    }
];

/**
 * Obtain the Datasets and labels for x Axe as a valid chartjs structure
 * @param chartData, data array with both metrics and dimension values
 * @param metrics, Array of Objects with the chartData fields to add as Datasets
 * @param dimension, chartData field for the labels of x Axe
 * @param chartType, internal chart type from our catalog
 * @param breaker, chartData for break metric into multiple Datasets if available
 * @return {Object} data object with datasets and xAxis labels for the chartJS instance
 */

export function calculateDatasets(chartData, metrics, dimension, chartType, breaker = null) {
    let data = {labels: [], datasets: []};

    let orderCriteria = { fields: [], criteria: [] }, orderedData;
    if (!breaker || isEmpty(breaker)) {
        metrics.forEach(metric => {
            if (!!metric && !!metric.order && metric.order !== 'default') {
                orderCriteria.fields.push(metric.field);
                orderCriteria.criteria.push(metric.order);
            }
        });
        if (orderCriteria.fields.length > 0 && orderCriteria.criteria.length > 0) {
            orderedData = orderBy(chartData, orderCriteria.fields, orderCriteria.criteria);
        } else if (dimension && dimension.field) {
            orderedData = orderBy(chartData, [dimension.field], [dimension.order]);
        } else {
            orderedData = cloneDeep(chartData);
        }
    } else if (dimension && dimension.field) {
        orderedData = orderBy(chartData, dimension.field);
    } else {
        orderedData = cloneDeep(chartData);
    }

    switch(chartType) {
        case 'pie':
        case 'doughnut':
            return calculateCircularDatasets(orderedData, metrics, dimension, chartType, breaker);
        case 'line':
        case 'bar':
        case 'mixed':
        case 'stackedBar':
        case 'stackedHorizontalBar':
        case 'horizontalBar':
        case 'area':
        case 'radar':
            return calculateLinearDatasets(orderedData, metrics, dimension, chartType, breaker);
        default:
            return data;
    }
}

/** Obtain the Datasets and labels for circular type charts (pies and doughnuts)
 * @param chartData, data array with both metrics and dimension values
 * @param metrics, Array of chartData fields to add as Datasets
 * @param dimension, chartData field for the chart dimension config
 * @param chartType, internal chart type from our catalog
 * @param breaker, chartData for break metric into multiple Datasets if available
 * @return {Object} data object with datasets and dimension labels for the chartJS instance
 * */
function calculateCircularDatasets(chartData, metrics, dimension, chartType, breaker = null) {
    let labelsTemp = [], label = '', backgroundColor = [], chart = getChartFromCatalog(chartType),
        data = {labels: [], datasets: []}, orderedData = cloneDeep(chartData);

    // let orderCriteria = { fields: [], criteria: [] };
    // metrics.forEach(metric => {
    //     if (!!metric && !!metric.order && metric.order !== 'default') {
    //         orderCriteria.fields.push(metric.field);
    //         orderCriteria.criteria.push(metric.order);
    //     }
    // });
    // if (orderCriteria.fields.length > 0 && orderCriteria.criteria.length > 0) {
    //     orderedData = orderBy(chartData, orderCriteria.fields, orderCriteria.criteria);
    // } else if (dimension && dimension.field){
    //     orderedData = orderBy(chartData, dimension.field);
    // } else {
    //     orderedData = cloneDeep(chartData);
    // }

    // if (dimension && dimension.field) {
    //     orderedData = orderBy(chartData, dimension.field);
    // } else {
    //     orderedData = cloneDeep(chartData);
    // }

    metrics.forEach((metric, index) => {
        labelsTemp.push(metric.label);
        if (metric.color) {
            backgroundColor.push(metric.color);
        } else {
            backgroundColor.push(chartColorPalette[index]);
        }
    });
    data.labels = labelsTemp;

    // Get the array of labels for the legend of the pie / doughnut chart
    if (breaker && !isEmpty(breaker) && chart.breakable && isArray(metrics) && metrics.length === 1) {
        data = breakCircularMetrics(metrics, dimension, breaker, chartData, chartType);
    } else if (isArray(metrics) && metrics.length === 1) {
        data = breakCircularMetrics(metrics, {}, dimension, chartData, chartType);
    } else {
        orderedData.forEach(d => {
            if (dimension.dataType === 'date') {
                if (dimension.formatLabel) {
                    if (dimension.format === 'WW') {
                        label = moment('2020' + d[dimension.field], 'YYYY' + dimension.format).format(dimension.formatLabel).toString();
                    } else if (dimension.format === 'YYYY-WW') {
                        label = d[dimension.field].toString();
                    } else {
                        label = moment(d[dimension.field], dimension.format).format(dimension.formatLabel).toString();
                    }
                } else {
                    // label = moment(d[dimension.field], dimension.format).format(dimension.format).toString();
                    label = d[dimension.field].toString();
                }
            } else if (dimension.dataType === 'number' && dimension.formatLabel) {
                label = numeral(d[dimension.field]).format(dimension.formatLabel).toString();
            } else {
                label = d[dimension.field] || '';
            }
            let datasetTemp = {label: label, backgroundColor: backgroundColor , borderWidth: 0, data: []};
            metrics.forEach(metric => {
                datasetTemp.data.push(d[metric.field]);
            });
            data.datasets.push(datasetTemp);
        });
    }
    return data;
}

/** Obtain the Datasets and labels for linear type charts (lines, bars, etc)
 * @param chartData, data array with both metrics and dimension values
 * @param metrics, Array of chartData fields to add as Datasets
 * @param dimension, chartData field for the chart dimension config
 * @param chartType, internal chart type from our catalog
 * @param breaker, chartData for break metric into multiple Datasets if available
 * @return {Object} data object with datasets and dimension labels for the chartJS instance
 * */
function calculateLinearDatasets(chartData, metrics, dimension, chartType, breaker = null) {
    let labelsTemp = [], label = '', chart = getChartFromCatalog(chartType),
        data = { labels: [], datasets: [] }, orderedData = cloneDeep(chartData);

    // let orderCriteria = { fields: [], criteria: [] };
    // metrics.forEach(metric => {
    //     if (!!metric && !!metric.order && metric.order !== 'default') {
    //         orderCriteria.fields.push(metric.field);
    //         orderCriteria.criteria.push(metric.order);
    //     }
    // });
    // if (orderCriteria.fields.length > 0 && orderCriteria.criteria.length > 0) {
    //     orderedData = orderBy(chartData, orderCriteria.fields, orderCriteria.criteria);
    // } else if (dimension && dimension.field){
    //     orderedData = orderBy(chartData, dimension.field);
    // } else {
    //     orderedData = cloneDeep(chartData);
    // }

    // if (dimension && dimension.field) {
    //     orderedData = orderBy(chartData, dimension.field);
    // } else {
    //     orderedData = cloneDeep(chartData);
    // }

    orderedData.forEach((d, index) => {
        if (label !== d[dimension.field]) {
            if (dimension.dataType === 'date') {
                if (index > 0 && moment(d[dimension.field], dimension.format).get('year').toString() !== moment(orderedData[index - 1][dimension.field], dimension.format).get('year').toString()) {
                    if (dimension.alternativeFormatLabel) {
                        label = moment(d[dimension.field], dimension.format).format(dimension.alternativeFormatLabel).toString();
                    } else if (dimension.formatLabel) {
                        if (dimension.format === 'WW') {
                            label = moment('2020' + d[dimension.field], 'YYYY' + dimension.format).format(dimension.formatLabel).toString();
                        } else if (dimension.format === 'YYYY-WW') {
                            label = d[dimension.field].toString();
                        } else {
                            label = moment(d[dimension.field], dimension.format).format(dimension.formatLabel).toString();
                        }
                    } else {
                        // label = moment(d[dimension.field], dimension.format).format(dimension.format).toString();
                        label = d[dimension.field].toString();
                    }
                } else if (dimension.formatLabel) {
                    if (dimension.format === 'WW') {
                        label = moment('2020' + d[dimension.field], 'YYYY' + dimension.format).format(dimension.formatLabel).toString();
                    } else if (dimension.format === 'YYYY-WW') {
                        label = d[dimension.field].toString();
                    } else {
                        label = moment(d[dimension.field], dimension.format).format(dimension.formatLabel).toString();
                    }
                } else {
                    // label = moment(d[dimension.field], dimension.format).format(dimension.format).toString();
                    label = d[dimension.field].toString();
                }
            } else if (dimension.dataType === 'number' && dimension.formatLabel) {
                label = numeral(d[dimension.field]).format(dimension.formatLabel).toString();
            } else {
                label = d[dimension.field] || '';
            }
            if (labelsTemp[labelsTemp.length-1] !== label && labelsTemp.indexOf(label) === -1) {
                labelsTemp.push(label);
            }
        }
    });
    data.labels = labelsTemp;

    // Check if there is a valid breaker config or if has to read directly from metrics array
    if (breaker && !isEmpty(breaker) && chart.breakable && metrics && metrics.length === 1) {
        data.datasets = breakLinearMetrics(metrics, dimension, breaker, chartData, chartType);
    } else if (metrics && metrics.length > 0) {
        metrics.forEach((metric, i) => {
            let dataTemp = [];
            orderedData.forEach((d, index) => {
                if (index === 0) {
                    label = metric.label;
                }
                dataTemp.push(d[metric.field]);
            });

            // Create basic dataset object info
            let datasetTemp = {
                label: label,
                data: dataTemp,
                fill: chartType === 'area' || chartType === 'radar',
                type: chartType === 'mixed' ? metric.type : null,
                formatLabel: metric.formatLabel
            };
            if (chart.orientation === 'horizontal') {
                datasetTemp.xAxisID = metric.yAxis;
                datasetTemp.yAxisID = metric.xAxis;
            } else {
                datasetTemp.xAxisID = metric.xAxis;
                datasetTemp.yAxisID = metric.yAxis;
            }

            if (metric.datalabels === false) {
                datasetTemp.datalabels = {
                    display: false
                };
            }

            if (chartType === 'stackedBar' || chartType === 'stackedHorizontalBar') {
                datasetTemp.stack = 0;
            }

            // Check if theres a color in metric settings, otherwise takes some color from the palette
            if (metric.color) {
                datasetTemp.backgroundColor = metric.color;
                datasetTemp.borderColor = metric.color;
            } else {
                datasetTemp.backgroundColor = chartColorPalette[i];
                datasetTemp.borderColor = chartColorPalette[i];
            }

            // Optional check for specific settings in line-type datasets
            // TODO: revisar los parametros que deban ir fijos y los que sean configurables
            Object.assign(datasetTemp, {
                borderWidth: metric.borderWidth,
                pointBorderWidth: metric.pointBorderWidth,
                pointRadius: metric.pointRadius,
                lineTension: metric.lineTension,
                pointBorderColor: metric.color || chartColorPalette[i],
                pointBackgroundColor: metric.color || chartColorPalette[i],
                pointHoverBorderColor: metric.color || chartColorPalette[i],
                pointHoverBackgroundColor: metric.color || chartColorPalette[i]
            });
            switch(chartType) {
                case 'area':
                    Object.assign(datasetTemp, {
                        borderWidth: metric.borderWidth || 2,
                        pointBorderWidth: metric.pointBorderWidth || 2,
                        pointRadius: metric.pointRadius || 2,
                        lineTension: metric.lineTension || 0,
                        backgroundColor: Color(datasetTemp.backgroundColor).alpha(0.5).rgbString()
                    });
                    break;
                case 'line':
                    Object.assign(datasetTemp, {
                        borderWidth: metric.borderWidth || 2,
                        pointBorderWidth: metric.pointBorderWidth || 1,
                        pointRadius: metric.pointRadius || 2,
                        lineTension: metric.lineTension || 0
                    });
                    break;
                case 'mixed':
                    if (metric.type === 'line') {
                        Object.assign(datasetTemp, {
                            borderWidth: metric.borderWidth || 2,
                            pointBorderWidth: metric.pointBorderWidth || 1,
                            pointRadius: metric.pointRadius || 2,
                            lineTension: metric.lineTension || 0
                        });
                    }
                    break;
                case 'radar':
                    Object.assign(datasetTemp, {
                        backgroundColor: Color(datasetTemp.backgroundColor).alpha(0.5).rgbString()
                    });
                    break;
                default:
                    break;
            }
            data.datasets.push(datasetTemp);
        });
    }
    return data;
}
/**
 * Datasets generator with break by functionality for linear type charts
 * @param metrics, array of metrics. Right now only one metric is supported
 * @param dimension, chart data dimension field
 * @param breaker, chart data breaker dimension field
 * @param chartData, data array with metrics, dimension and breaker values
 * @param chartType, chart type from catalog
 * @return Object, array of datasets for chart.js
 */
function breakLinearMetrics(metrics, dimension, breaker, chartData, chartType) {
    let brokenDatasets = [], breakValues = [], orderedData = cloneDeep(chartData), dimValues = [];

    // let orderCriteria = { fields: [], criteria: [] };
    // metrics.forEach(metric => {
    //     if (!!metric && !!metric.order && metric.order !== 'default') {
    //         orderCriteria.fields.push(metric.field);
    //         orderCriteria.criteria.push(metric.order);
    //     }
    // });
    // if (orderCriteria.fields.length > 0 && orderCriteria.criteria.length > 0) {
    //     orderedData = orderBy(chartData, orderCriteria.fields, orderCriteria.criteria);
    // } else if (dimension && dimension.field){
    //     orderedData = orderBy(chartData, dimension.field);
    // } else {
    //     orderedData = cloneDeep(chartData);
    // }

    // if (dimension && dimension.field) {
    //     orderedData = orderBy(chartData, dimension.field);
    // } else {
    //     orderedData = cloneDeep(chartData);
    // }

    orderedData.forEach(d => {
        if (indexOf(breakValues, d[breaker.field]) === -1) {
            breakValues.push(d[breaker.field]);
        }
        if (indexOf(dimValues, d[dimension.field]) === -1) {
            dimValues.push(d[dimension.field]);
        }
    });
    breakValues.sort();

    breakValues.forEach((value, index) => {
        let dataTemp = new Array(dimValues.length);
        orderedData.forEach(d => {
            let dataIndex = indexOf(dimValues, d[dimension.field]);
            if (!dataTemp[dataIndex]) {
                if (d[breaker.field] === value) {
                    dataTemp[dataIndex] = d[metrics[0].field];
                } else dataTemp[dataIndex] = null;
            }
        });
        let datasetTemp = {
            color: chartColorPalette[index],
            borderWidth: metrics[0].borderWidth,
            pointBorderWidth: metrics[0].pointBorderWidth,
            pointRadius: metrics[0].pointRadius,
            lineTension: metrics[0].lineTension,
            borderColor: metrics[0].color || chartColorPalette[index],
            pointBorderColor: metrics[0].color || chartColorPalette[index],
            pointBackgroundColor: metrics[0].color || chartColorPalette[index],
            pointHoverBorderColor: metrics[0].color || chartColorPalette[index],
            pointHoverBackgroundColor: metrics[0].color || chartColorPalette[index],
            backgroundColor:chartColorPalette[index],
            data: dataTemp,
            label: value,
            stack: 0,
            yAxisID: metrics[0].yAxis,
            xAxisID:  metrics[0].xAxis
        };

        switch(chartType) {
            case 'area':
                Object.assign(datasetTemp, {
                    borderWidth: metrics[0].borderWidth || 2,
                    pointBorderWidth: metrics[0].pointBorderWidth || 2,
                    pointRadius: metrics[0].pointRadius || 2,
                    lineTension: metrics[0].lineTension || 0,
                    backgroundColor: Color(datasetTemp.backgroundColor).alpha(0.5).rgbString()
                });
                break;
            case 'line':
                Object.assign(datasetTemp, {
                    borderWidth: metrics[0].borderWidth || 2,
                    pointBorderWidth: metrics[0].pointBorderWidth || 1,
                    pointRadius: metrics[0].pointRadius || 2,
                    lineTension: metrics[0].lineTension || 0,
                    fill: false
                });
                break;
            case 'mixed':
                if (metrics[0].type === 'line') {
                    Object.assign(datasetTemp, {
                        borderWidth: metrics[0].borderWidth || 2,
                        pointBorderWidth: metrics[0].pointBorderWidth || 1,
                        pointRadius: metrics[0].pointRadius || 2,
                        lineTension: metrics[0].lineTension || 0
                    });
                }
                break;
            case 'radar':
                Object.assign(datasetTemp, {
                    backgroundColor: Color(datasetTemp.backgroundColor).alpha(0.5).rgbString()
                });
                break;
            default:
                break;
        }

        if (getChartFromCatalog(chartType).orientation === 'horizontal') {
            datasetTemp.yAxisID = metrics[0].xAxis;
            datasetTemp.xAxisID = metrics[0].yAxis;
        }
        brokenDatasets.push(datasetTemp);
    });
    return brokenDatasets;
}

/**
 * Datasets generator with break by functionality for cirular type charts
 * @param metrics, array of metrics. Right now only one metric is supported
 * @param dimension, chart data dimension field
 * @param breaker, chart data breaker dimension field
 * @param chartData, data array with metrics, dimension and breaker values
 * @param chartType, chart type from catalog
 * @return Object, data object with array of datasets and dimension labels for chart.js
 */
function breakCircularMetrics(metrics, dimension, breaker, chartData, chartType) {
    let data = {datasets: [], labels: []}, brokenDatasets = [],
        breakValues = [], backgroundColor = [], orderedData = cloneDeep(chartData), dimValues = [];

    // let orderCriteria = { fields: [], criteria: [] };
    // metrics.forEach(metric => {
    //     if (!!metric && !!metric.order && metric.order !== 'default') {
    //         orderCriteria.fields.push(metric.field);
    //         orderCriteria.criteria.push(metric.order);
    //     }
    // });
    // if (orderCriteria.fields.length > 0 && orderCriteria.criteria.length > 0) {
    //     orderedData = orderBy(chartData, orderCriteria.fields, orderCriteria.criteria);
    // } else if (dimension && dimension.field){
    //     orderedData = orderBy(chartData, dimension.field);
    // } else {
    //     orderedData = cloneDeep(chartData);
    // }

    // if (dimension && dimension.field) {
    //     orderedData = orderBy(chartData, dimension.field);
    // } else {
    //     orderedData = orderBy(chartData, breaker.field);
    // }

    orderedData.forEach(d => {
        if (indexOf(breakValues, d[breaker.field]) === -1) {
            breakValues.push(d[breaker.field]);
        }
        if (indexOf(dimValues, d[dimension.field]) === -1) {
            dimValues.push(d[dimension.field]);
        }
    });
    breakValues.sort();
    breakValues.forEach((value, index) => {
        backgroundColor.push(chartColorPalette[index]);
    });
    data.labels = breakValues.map(value => {
        if (breaker.dataType === 'date') {
            let label = '';
            if (breaker.formatLabel) {
                if (breaker.format === 'WW') {
                    label = moment('2020' + value, 'YYYY' + breaker.format).format(breaker.formatLabel).toString();
                } else if (breaker.format === 'YYYY-WW') {
                    label = value.toString();
                } else {
                    label = moment(value, breaker.format).format(breaker.formatLabel).toString();
                }
            } else {
                // label = moment(value, breaker.format).format(breaker.format).toString();
                label = value;
            }
            return label;
        } else {
            return value;
        }
    });

    dimValues.forEach((dim, index) => {
        let filteredData = filter(orderedData, o => {
            if (!!o) {
                return o[dimension.field] === dim;
            } else return true;
        });
        let dataTemp = new Array(breakValues.length);
        filteredData = orderBy(filteredData, breaker.field);

        filteredData.forEach(d => {
            let dataIndex = indexOf(breakValues, d[breaker.field]);
            if (!dataTemp[dataIndex]) {
                dataTemp[dataIndex] = d[metrics[0].field];
            }
        });

        let datasetTemp = {
            color: backgroundColor,
            borderWidth: metrics[0].borderWidth,
            pointBorderWidth: metrics[0].pointBorderWidth,
            pointRadius: metrics[0].pointRadius,
            lineTension: metrics[0].lineTension,
            borderColor: backgroundColor,
            pointBorderColor: backgroundColor,
            pointBackgroundColor: backgroundColor,
            pointHoverBorderColor: backgroundColor,
            pointHoverBackgroundColor: backgroundColor,
            backgroundColor: backgroundColor,
            data: dataTemp,
            label: dim
        };
        switch(chartType) {
            case 'pie':
                break;
            case 'doughnut':
                break;
            default:
                break;
        }
        brokenDatasets.push(datasetTemp);
    });

    data.datasets = brokenDatasets;

    return data;
}

/**
 * Returns a chart from catalog converted to a type that chartJS can understand
 * @param name Name of the chart in the chartCatalog
 * @returns chartType
 */
export function getChartType(name) {
    let chart = find(chartCatalog, {value: name});
    if (chart) {
        return chart.type;
    } else return null;
}

/**
 * Returns the chart family from a specific chart type from catalog
 * @param name Name of the chart in the chartCatalog
 * @returns chartFamily
 */
export function getChartFamily(name) {
    let chart = find(chartCatalog, {value: name});
    if (chart) {
        return chart.family;
    } else return null;
}

/**
 * Returns chart info object from a specific chart type from catalog with all data related (type, family, orientation, etc)
 * @param name Name of the chart in the chartCatalog
 * @returns chart info as JSON object
 */
export function getChartFromCatalog(name) {
    let chart = find(chartCatalog, {value: name});
    if (chart) {
        return chart;
    } else return null;
}

/**
 * Obtain the graphic options as a valid chartjs structure
 * @param {Object} config, chart config object given by props to ChartComponent
 * @return {Object} for chartJS instance
 */
export function calculateOptions(config) {
    let options  = {}, chart = getChartFromCatalog(config.graph.type);
    const { metrics/*, breakBy*/ } = config.data;

    // Maintain aspect ratio option
    // Maintain the original canvas aspect ratio (width / height) when resizing
    // Default value in chartjs core is true, but for better responsive view here is set by default as false
    options.maintainAspectRatio = !!config.graph.maintainAspectRatio ? config.graph.maintainAspectRatio : false;
    options.responsive = true;

    // Legend options
    // The chart legend displays data about the datasets that area appearing on the chart.
    // Add a boxWidth style to set color labels as squares
    if (config.graph.legend && config.graph.legend.show) {
        options.legend = {
            display: config.graph.legend.show,
            position: config.graph.legend.position || 'bottom',
            labels: { boxWidth: 12 }
        };
    } else {
        options.legend = { display: false };
    }

    // Hover options
    // Hover interactions with graphics
    if (config.graph.hover) {
        options.hover = {
            mode: config.graph.hover.mode || 'index',
            intersect: config.graph.hover.intersect !== null ? config.graph.hover.intersect : false
        };
    } else {
        options.hover = {
            mode: 'index',
            intersect: true
        };
    }

    // Tooltip options
    // Configuration for the box that appears with data on hover events
    if (config.graph.tooltip && config.graph.tooltip.show) {
        options.tooltips = {
            enabled: config.graph.tooltip.show,
            mode: config.graph.tooltip.mode || 'point',
            intersect: config.graph.tooltip.intersect !== null ? config.graph.tooltip.intersect : true,
            position: config.graph.tooltip.position || 'average',
            callbacks: {
                label: (tooltipItem, data) => {
                    let label = data.datasets[tooltipItem.datasetIndex].label,
                        value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index],
                        format = data.datasets[tooltipItem.datasetIndex].formatLabel;
                    if (format) {
                        value = numeral(value).format(format);
                    } else if (value && !isNaN(Number(value))) {
                        value = numeral(value).format('0,0.[00]');
                    } else {
                        value = (value && value.toString()) || '0';
                    }
                    return (label + ': ' + value);
                }
            }
        };
        if (chart && (chart.type === 'doughnut' || chart.type === 'pie')) {
            options.tooltips.mode = 'point';
        }
    } else {
        options.tooltips = {
            enabled: false
        };
    }

    if (config.graph.datalabels && config.graph.datalabels.show) {
        options.plugins = Object.assign(options.plugins||{}, {
            datalabels: {
                display: (context) => {
                    let data = context.dataset.data[context.dataIndex], maxValue = max(context.dataset.data), minValue = 0, axis,
                        labelWidth, labelHeight, labelMeasures, lineWidth, barWidth, barHeight, meta, validMeasures = true;
                    switch(context.chart.config.type) {
                        case 'horizontalBar':
                            if (context.dataset.xAxisID) {
                                axis = null;
                                axis = find(context.chart.scales, { id: context.dataset.xAxisID });
                                if (axis) {
                                    minValue = axis.min >= 0 ? axis.min : 0;
                                    maxValue = axis.min >= 0 ? axis.max : Math.abs(axis.min);
                                }
                            }
                            meta = context.chart.config.data.datasets[context.datasetIndex]._meta;
                            Object.keys(meta).forEach(key => {
                                barHeight = meta[key].data[context.dataIndex]._model.height;
                                if (context.dataset.formatLabel) {
                                    labelMeasures = getTextMeasures(numeral(data).format(context.dataset.formatLabel));
                                } else {
                                    labelMeasures = getTextMeasures(data);
                                }
                                labelHeight = labelMeasures.height + 9;
                                labelWidth = labelMeasures.width + ((config.graph.datalabels.borderWidth || 0) * 2) + 8;
                                validMeasures = (labelHeight < barHeight) && (labelWidth < ((data-minValue)/maxValue * 100) * 12);
                            });

                            return validMeasures;
                        case 'bar':
                            if (context.dataset.yAxisID) {
                                axis = null;
                                axis = find(context.chart.scales, { id: context.dataset.yAxisID });
                                if (axis) {
                                    minValue = axis.min >= 0 ? axis.min : 0;
                                    maxValue = axis.min >= 0 ? axis.max : Math.abs(axis.min);
                                }
                            }
                            meta = context.chart.config.data.datasets[context.datasetIndex]._meta;
                            Object.keys(meta).forEach(key => {
                                if (meta[key].data) {
                                    barWidth = meta[key].data[context.dataIndex]._model.width;
                                    if (context.dataset.formatLabel) {
                                        labelMeasures = getTextMeasures(numeral(data).format(context.dataset.formatLabel));
                                    } else {
                                        labelMeasures = getTextMeasures(data);
                                    }
                                    labelHeight = labelMeasures.height + 9;
                                    labelWidth = labelMeasures.width + ((config.graph.datalabels.borderWidth || 0) * 2) + 10;
                                    validMeasures = labelWidth < barWidth;
                                }
                            });

                            // TODO: caso especial para datalabels en graficos mixtos
                            if (config.graph.type === 'mixed') {}
                            return (((data-minValue)/maxValue >= 0.12) && validMeasures);
                        case 'line':
                            if (context.dataset.yAxisID) {
                                // eslint-disable-next-line
                                axis = null;
                                let axis = find(context.chart.scales, { id: context.dataset.yAxisID });
                                if (axis) {
                                    minValue = axis.min >= 0 ? axis.min : 0;
                                    maxValue = axis.min >= 0 ? axis.max : Math.abs(axis.min);
                                }
                            }
                            if (context.dataset.formatLabel) {
                                labelMeasures = getTextMeasures(numeral(data).format(context.dataset.formatLabel));
                            } else {
                                labelMeasures = getTextMeasures(data);
                            }
                            labelHeight = labelMeasures.height + 8;
                            labelWidth = labelMeasures.width + ((config.graph.datalabels.borderWidth || 0) * 2) + 12;
                            meta = context.chart.config.data.datasets[context.datasetIndex]._meta;
                            Object.keys(meta).forEach(key => {
                                if (meta[key].data) {
                                    let backIndex = context.dataIndex > 0 ? (meta[key].data[context.dataIndex]._view.x - meta[key].data[context.dataIndex - 1]._view.x)/2 : 0,
                                        frontIndex = context.dataIndex < meta[key].data.length - 1 ? (meta[key].data[context.dataIndex + 1]._view.x -meta[key].data[context.dataIndex]._view.x)/2 : 0;
                                    lineWidth = backIndex + frontIndex;
                                    if (backIndex !== 0 && frontIndex !== 0) {
                                        validMeasures = labelWidth < lineWidth;
                                    } else validMeasures = false;
                                }
                            });
                            return (((data-minValue)/maxValue >= 0.1) && ((data-minValue)/maxValue <= 0.9) && validMeasures);
                        case 'pie':
                        case 'doughnut':
                            Object.keys(context.dataset._meta).forEach(key => {
                                if (context.dataset._meta[key].data) {
                                    let data = [];
                                    context.dataset._meta[key].data.forEach(d => {
                                        if (!d.hidden) {
                                            data.push(context.dataset.data[d._index]);
                                        }
                                    });
                                    maxValue = sum(data) || maxValue;
                                }
                            });

                            let pieLength = context.chart.radiusLength;
                            if (context.dataset.formatLabel) {
                                labelMeasures = getTextMeasures(numeral(data).format(context.dataset.formatLabel));
                            } else {
                                labelMeasures = getTextMeasures(data);
                            }
                            labelHeight = labelMeasures.height + 9;
                            labelWidth = labelMeasures.width + ((config.graph.datalabels.borderWidth || 0) * 2) + 10;
                            validMeasures = labelWidth < (pieLength * 1.55) && labelHeight < pieLength;
                            return ((data/maxValue >= 0.1) && validMeasures);
                        case 'radar':
                            return config.graph.datalabels.show;
                        default:
                            return 'center';
                    }
                },
                anchor: (context) => {
                    switch (context.chart.config.type) {
                        case 'pie':
                        case 'doughnut':
                            return 'center';
                        case 'line':
                        case 'bar':
                        case 'horizontalBar':
                            if (config.graph.type === 'mixed') {
                                switch(context.dataset.type) {
                                    case 'line':
                                    case 'bar':
                                    default:
                                        return 'center';
                                }
                            }
                            return 'center';
                        case 'radar':
                            return 'end';
                        default:
                            return 'center';
                    }
                },
                align: (context) => {
                    switch (context.chart.config.type) {
                        case 'pie':
                        case 'doughnut':
                            return 'center';
                        case 'line':
                            return 'end';
                        case 'bar':
                        case 'horizontalBar':
                        case 'radar':
                            if (config.graph.type === 'mixed') {
                                let metric = metrics[context.datasetIndex];
                                switch(metric.type) {
                                    case 'line':
                                        return 'end';
                                    case 'bar':
                                    default:
                                        return 'center';
                                }
                            }
                            return 'center';
                        default:
                            return 'center';
                    }
                },
                backgroundColor: (context) => {
                    if (context.chart.config.type === 'bar' && config.graph.datalabels.position === 'end') {
                        return context.dataset.borderColor;
                    } else if (context.chart.config.type === 'bar' ||
                        context.chart.config.type === 'horizontalBar' ||
                        context.chart.config.type === 'pie' ||
                        context.chart.config.type === 'doughnut' ||
                        (config.graph.type === 'mixed' && context.dataset.type === 'line')) {
                        return 'transparent';
                    }
                    return context.dataset.borderColor;
                },
                borderRadius: 4,
                color: 'white',
                // font: {
                //     weight: 'bold'
                // },
                formatter: (value, context) => {
                    let metric = metrics[context.datasetIndex];
                    if (chart.type === 'pie' || chart.type === 'doughnut') {
                        metric = metrics[context.dataIndex];
                    }
                    if (metric && context.dataset.formatLabel) {
                        return numeral(value).format(context.dataset.formatLabel);
                    } else return value;
                }
            }
        });

        // Explicit datalabels position setting if provided by chartConfig
        switch(config.graph.datalabels.position) {
            case 'start':
                Object.assign(options.plugins.datalabels, {
                    anchor: 'start',
                    align: 'end'
                });
                break;
            case 'underPoint':
                Object.assign(options.plugins.datalabels, {
                    anchor: 'center',
                    align: 'start'
                });
                break;
            case 'overPoint':
                Object.assign(options.plugins.datalabels, {
                    anchor: 'center',
                    align: 'end'
                });
                break;
            case 'point':
            case 'center':
                Object.assign(options.plugins.datalabels, {
                    anchor: 'center',
                    align: 'center'
                });
                break;
            case 'end':
                Object.assign(options.plugins.datalabels, {
                    anchor: 'end',
                    align: 'start'
                });
                break;
            case 'out':
                Object.assign(options.plugins.datalabels, {
                    anchor: 'end',
                    align: 'end'
                });
                break;
            default:
                break;
        }
        if (config.graph.datalabels.custom) {
            Object.assign(options.plugins.datalabels, {
                borderColor: config.graph.datalabels.borderColor || 'transparent',
                borderWidth: config.graph.datalabels.borderWidth,
                color: config.graph.datalabels.color || 'white',
                backgroundColor: config.graph.datalabels.backgroundColor || 'transparent'
            });
        }
    } else {
        options.plugins = Object.assign(options.plugins||{}, {
            datalabels: {
                display: false
            }
        });
    }

    // Animation options
    // Global config of the chart animations
    //TODO: regresar mas tarde
    // if (config.graph.animation) {
    //     options.animation = {};
    // }

    switch(chart.type) {
        case 'pie':
        case 'doughnut':

            // Callback for set the dataset label as the tooltip title
            if (options.tooltips && options.tooltips.callbacks) {
                options.tooltips.callbacks.title = (tooltipItem, data) => {
                    return data.datasets[tooltipItem[0].datasetIndex].label;
                };
                options.tooltips.callbacks.label = (tooltipItem, data) => {
                    let label = data.labels[tooltipItem.index],
                        value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index],
                        format = data.datasets[tooltipItem.datasetIndex].formatLabel;
                    if (format) {
                        value = numeral(value).format(format);
                    } else if (value && !isNaN(Number(value))) {
                        value = numeral(value).format('0,0.[00]');
                    } else {
                        value = (value && value.toString()) || '0';
                    }
                    return (label + ': ' + value);
                };
            }
            break;
        case 'line':
        case 'bar':

            // Legend onClick Mod for hide the axis that has not an associated metric visible
            if (options.legend && options.legend.display) {
                options.legend.onClick = function(e, legendItem) {
                    let ci = this.chart, meta = ci.getDatasetMeta(legendItem.datasetIndex),
                        xAxis = find(ci.config.options.scales.xAxes, {id: meta.xAxisID}),
                        yAxis = find(ci.config.options.scales.yAxes, {id: meta.yAxisID}), metaDataset;

                    // See controller.isDatasetVisible comment
                    meta.hidden = meta.hidden === null ? !ci.data.datasets[legendItem.datasetIndex].hidden : null;
                    xAxis.display = !meta.hidden;
                    yAxis.display = !meta.hidden;
                    ci.config.data.datasets.forEach((ds, index) => {
                        if (ci.getDatasetMeta(index).yAxisID === yAxis.id && index !== legendItem.datasetIndex) {
                            metaDataset = ci.getDatasetMeta(index);
                            if (metaDataset.hidden === null) { yAxis.display = true; }
                        }
                        if (ci.getDatasetMeta(index).xAxisID === xAxis.id && index !== legendItem.datasetIndex) {
                            metaDataset = ci.getDatasetMeta(index);
                            if (metaDataset.hidden === null) { xAxis.display = true; }
                        }
                    });

                    // We hid a dataset ... rerender the chart
                    ci.update();
                }
            }

            // xAxis options
            // Right now config is limited to just one xAxis per chart for vertical charts and the same for yAxis on horizontal charts
            options.scales = {
                xAxes: [],
                yAxes: []
            };

            if (config.axis) {
                if (config.axis.xAxis && !isEmpty(config.axis.xAxis)) {
                    let xAxis, gridLines = {}, ticks = {};
                    if (config.axis.xAxis.gridLines && config.axis.xAxis.gridLines.show) {
                        gridLines = {
                            display: config.axis.xAxis.gridLines.show || false,
                            drawBorder: true /*config.axis.xAxis.gridLines.border || false*/
                        };
                        Object.assign(gridLines, {
                            borderDash:config.axis.xAxis.gridLines.lineDash || [],
                            borderDashOffset: Number(config.axis.xAxis.gridLines.lineDashOffset || 0),
                            lineWidth: config.axis.xAxis.gridLines.lineWidth ? Number(config.axis.xAxis.gridLines.lineWidth) : 1,
                            zeroLineBorderDash: config.axis.xAxis.gridLines.zeroLineDash || [],
                            zeroLineBorderDashOffset: Number(config.axis.xAxis.gridLines.zeroLineDashOffset || 0),
                            zeroLineWidth: config.axis.xAxis.gridLines.zeroLineWidth ? Number(config.axis.xAxis.gridLines.zeroLineWidth) : 1
                        });

                        if (config.axis.xAxis.gridLines.color) {
                            gridLines.color = config.axis.xAxis.gridLines.color;
                        }
                        if (config.axis.xAxis.gridLines.zeroLineColor) {
                            gridLines.zeroLineColor = config.axis.xAxis.gridLines.zeroLineColor;
                        }
                    } else {
                        gridLines = { display: false };
                    }

                    // Ticks config for xAxis
                    // At this moment this option is not editable in xAxis beyond if is enabled or disabled
                    if (config.axis.xAxis.ticks && config.axis.xAxis.ticks.show) {
                        ticks = {
                            display: config.axis.xAxis.ticks.show,
                            beginAtZero: config.axis.xAxis.ticks.beginAtZero === null || config.axis.xAxis.ticks.beginAtZero === undefined ?
                                true : config.axis.xAxis.ticks.beginAtZero,
                            autoSkip: true,
                            maxTicksLimit: 25
                        };

                        // Custom callback to show config.axis.xAxis ticks with the given numeral format
                        // If there is no numeral format in config.axis.xAxis config, callback is ignored
                        if (config.axis.xAxis.format) {
                            ticks.callback = (value, index, values) => {
                                return numeral(value).format(config.axis.xAxis.format);
                            };
                        }

                        // if custom is true, set the min, max and stepsize from config
                        if (config.axis.xAxis.ticks.custom) {
                            if (config.axis.xAxis.ticks.min) {
                                Object.assign(ticks, { min: Number(config.axis.xAxis.ticks.min) });
                            }
                            if (config.axis.xAxis.ticks.max) {
                                Object.assign(ticks, { max: Number(config.axis.xAxis.ticks.max) });
                            }
                            if (config.axis.xAxis.ticks.stepSize) {
                                Object.assign(ticks, { stepSize: Number(config.axis.xAxis.ticks.stepSize) });
                            }
                        }

                        switch (config.axis.xAxis.ticks.direction) {
                            case 'horizontal':
                                ticks.minRotation = 0;
                                ticks.maxRotation = 0;
                                break;
                            case 'vertical':
                                ticks.minRotation = 90;
                                ticks.maxRotation = 90;
                                break;
                            case 'slanting':
                                ticks.minRotation = 45;
                                ticks.maxRotation = 45;
                                break;
                            default:
                                break;
                        }

                    } else {
                        ticks = { display: false };
                    }

                    xAxis = {
                        gridLines: gridLines,
                        ticks: ticks,
                        id: config.axis.xAxis.id,
                        position: config.axis.xAxis.position || 'bottom',
                        stacked: config.graph.type === 'stackedBar'
                    };
                    if (config.axis.xAxis.axisLabel && config.axis.xAxis.axisLabel.show) {
                        xAxis.scaleLabel = {
                            display: config.axis.xAxis.axisLabel.show,
                            labelString: config.axis.xAxis.axisLabel.label || ''
                        };
                    }

                    options.scales.xAxes.push(xAxis);
                } else {
                    options.scales.xAxes = [{
                        gridLines: { display: false },
                        ticks: { autoSkip: true },
                        stacked: config.graph.type === 'stackedBar'
                    }];
                }
                if (config.axis.yAxis) {
                    if (config.axis.yAxis.sideA && config.axis.yAxis.sideA.length > 0) {
                        config.axis.yAxis.sideA.forEach(axe => {
                            let yAxis, gridLines = {}, ticks = {};

                            // GridLines config for yAxis
                            if (axe.gridLines && axe.gridLines.show) {
                                gridLines = {
                                    display: axe.gridLines.show || false,
                                    drawBorder: true/*axe.gridLines.border || false*/
                                };
                                Object.assign(gridLines, {
                                    borderDash: axe.gridLines.lineDash || [],
                                    borderDashOffset: Number(axe.gridLines.lineDashOffset || 0),
                                    lineWidth: axe.gridLines.lineWidth ? Number(axe.gridLines.lineWidth) : 1,
                                    zeroLineBorderDash: axe.gridLines.zeroLineDash || [],
                                    zeroLineBorderDashOffset: Number(axe.gridLines.zeroLineDashOffset || 0),
                                    zeroLineWidth: axe.gridLines.zeroLineWidth ? Number(axe.gridLines.zeroLineWidth) : 1,
                                });
                                if (axe.gridLines.color) {
                                    gridLines.color = axe.gridLines.color;
                                }
                                if (axe.gridLines.zeroLineColor) {
                                    gridLines.zeroLineColor = axe.gridLines.zeroLineColor;
                                }
                            } else {
                                gridLines = { display: false };
                            }

                            // Ticks config for yAxis
                            if (axe.ticks && axe.ticks.show) {
                                ticks = {
                                    display: axe.ticks.show,
                                    beginAtZero: axe.ticks.beginAtZero === null || axe.ticks.beginAtZero === undefined ?
                                        true : axe.ticks.beginAtZero,
                                    maxTicksLimit: 25
                                };

                                // Custom callback to show axe ticks with the given numeral format
                                // If there is no numeral format in axe config, callback is ignored
                                if (axe.format) {
                                    ticks.callback = (value, index, values) => {
                                        return numeral(value).format(axe.format);
                                    };
                                }

                                // if custom is true, set the min, max and stepsize from config
                                if (axe.ticks.custom) {
                                    if (axe.ticks.min) {
                                        Object.assign(ticks, { min: Number(axe.ticks.min) });
                                    }
                                    if (axe.ticks.max) {
                                        Object.assign(ticks, { max: Number(axe.ticks.max) });
                                    }
                                    if (axe.ticks.stepSize) {
                                        Object.assign(ticks, { stepSize: Number(axe.ticks.stepSize) });
                                    }
                                }
                            } else {
                                ticks = { display: false, beginAtZero: true };
                            }

                            // Put all together before push into the axes array in options
                            yAxis = {
                                id: axe.id,
                                position: 'left',
                                gridLines: gridLines,
                                ticks: ticks,
                                stacked: config.graph.type === 'stackedBar'
                            };

                            // TODO: scaleLabels from axisLabel with custom style options
                            if (axe.axisLabel && axe.axisLabel.show) {
                                yAxis.scaleLabel = {
                                    display: axe.axisLabel.show,
                                    labelString: axe.axisLabel.label || ''
                                };
                                if (axe.axisLabel.color) {
                                    yAxis.scaleLabel.fontColor = axe.axisLabel.color
                                }
                                if (axe.axisLabel.fontFamily) {
                                    yAxis.scaleLabel.fontFamily = axe.axisLabel.fontFamily
                                }
                                if (axe.axisLabel.fontSize) {
                                    yAxis.scaleLabel.fontSize = axe.axisLabel.fontSize
                                }
                                if (axe.axisLabel.fontStyle) {
                                    yAxis.scaleLabel.fontStyle = axe.axisLabel.fontStyle
                                }
                            }
                            options.scales.yAxes.push(yAxis);
                        });
                    }
                    if (config.axis.yAxis.sideB && config.axis.yAxis.sideB.length > 0) {
                        config.axis.yAxis.sideB.forEach(axe => {
                            let yAxis, gridLines = {}, ticks = {};

                            // GridLines config for yAxis
                            if (axe.gridLines && axe.gridLines.show) {
                                gridLines = {
                                    display: axe.gridLines.show || false,
                                    drawBorder: true/*axe.gridLines.border || false*/
                                };
                                Object.assign(gridLines, {
                                    borderDash: axe.gridLines.lineDash || [],
                                    borderDashOffset: Number(axe.gridLines.lineDashOffset || 0),
                                    lineWidth: axe.gridLines.lineWidth ? Number(axe.gridLines.lineWidth) : 1,
                                    zeroLineBorderDash: axe.gridLines.zeroLineDash || [],
                                    zeroLineBorderDashOffset: Number(axe.gridLines.zeroLineDashOffset || 0),
                                    zeroLineWidth: axe.gridLines.zeroLineWidth ? Number(axe.gridLines.zeroLineWidth) : 1,
                                });
                                if (axe.gridLines.color) {
                                    gridLines.color = axe.gridLines.color;
                                }
                                if (axe.gridLines.zeroLineColor) {
                                    gridLines.zeroLineColor = axe.gridLines.zeroLineColor;
                                }
                            } else {
                                gridLines = { display: false };
                            }

                            // Ticks config for yAxis
                            if (axe.ticks && axe.ticks.show) {
                                ticks = {
                                    display: axe.ticks.show,
                                    beginAtZero: axe.ticks.beginAtZero === null || axe.ticks.beginAtZero === undefined ?
                                        true : axe.ticks.beginAtZero,
                                    maxTicksLimit: 25
                                };

                                // Custom callback to show axe ticks with the given numeral format
                                // If there is no numeral format in axe config, callback is ignored
                                if (axe.format) {
                                    ticks.callback = (value, index, values) => {
                                        return numeral(value).format(axe.format);
                                    };
                                }

                                // if custom is true, set the min, max and stepsize from config
                                if (axe.ticks.custom) {
                                    if (axe.ticks.min) {
                                        Object.assign(ticks, { min: Number(axe.ticks.min) });
                                    }
                                    if (axe.ticks.max) {
                                        Object.assign(ticks, { max: Number(axe.ticks.max) });
                                    }
                                    if (axe.ticks.stepSize) {
                                        Object.assign(ticks, { stepSize: Number(axe.ticks.stepSize) });
                                    }
                                }

                            } else {
                                ticks = { display: false, beginAtZero: true };
                            }

                            // Put all together before push into the axes array in options
                            yAxis = {
                                id: axe.id,
                                position: 'right',
                                gridLines: gridLines,
                                ticks: ticks,
                                stacked: config.graph.type === 'stackedBar'
                            };

                            // TODO: scaleLabels from axisLabel with custom style options
                            if (axe.axisLabel && axe.axisLabel.show) {
                                yAxis.scaleLabel = {
                                    display: axe.axisLabel.show,
                                    labelString: axe.axisLabel.label || ''
                                };
                            }
                            options.scales.yAxes.push(yAxis);
                        });
                    }
                }
            }
            break;

        // Horizontal charts has xAxis(config) on yAxes(options) and yAxis(config) on xAxes(options)
        case 'horizontalBar':

            // Legend onClick Mod for hide the axis that has not an associated metric visible
            if (options.legend && options.legend.display) {
                options.legend.onClick = function(e, legendItem) {
                    let ci = this.chart, meta = ci.getDatasetMeta(legendItem.datasetIndex),
                        xAxis = find(ci.config.options.scales.xAxes, {id: meta.xAxisID}),
                        yAxis = find(ci.config.options.scales.yAxes, {id: meta.yAxisID}), metaDataset;

                    // See controller.isDatasetVisible comment
                    meta.hidden = meta.hidden === null ? !ci.data.datasets[legendItem.datasetIndex].hidden : null;
                    xAxis.display = !meta.hidden;
                    yAxis.display = !meta.hidden;
                    ci.config.data.datasets.forEach((ds, index) => {
                        if (ci.getDatasetMeta(index).yAxisID === yAxis.id && index !== legendItem.datasetIndex) {
                            metaDataset = ci.getDatasetMeta(index);
                            if (metaDataset.hidden === null) { yAxis.display = true; }
                        }
                        if (ci.getDatasetMeta(index).xAxisID === xAxis.id && index !== legendItem.datasetIndex) {
                            metaDataset = ci.getDatasetMeta(index);
                            if (metaDataset.hidden === null) { xAxis.display = true; }
                        }
                    });

                    // We hid a dataset ... rerender the chart
                    ci.update();
                }
            }

            // xAxis options
            // Right now config is limited to just one xAxis per chart for vertical charts and the same for yAxis on horizontal charts
            options.scales = {
                xAxes: [],
                yAxes: []
            };

            if (config.axis) {
                if (config.axis.xAxis && !isEmpty(config.axis.xAxis)) {
                    let xAxis, gridLines = {}, ticks = {};
                    if (config.axis.xAxis.gridLines && config.axis.xAxis.gridLines.show) {
                        gridLines = {
                            display: config.axis.xAxis.gridLines.show || false,
                            drawBorder: true /*config.axis.xAxis.gridLines.border || false*/
                        };
                        Object.assign(gridLines, {
                            borderDash: config.axis.xAxis.gridLines.lineDash || [],
                            borderDashOffset: Number(config.axis.xAxis.gridLines.lineDashOffset || 0),
                            lineWidth: config.axis.xAxis.gridLines.lineWidth ? Number(config.axis.xAxis.gridLines.lineWidth) : 1,
                            zeroLineBorderDash: config.axis.xAxis.gridLines.zeroLineDash || [],
                            zeroLineBorderDashOffset: Number(config.axis.xAxis.gridLines.zeroLineDashOffset || 0),
                            zeroLineWidth: config.axis.xAxis.gridLines.zeroLineWidth ? Number(config.axis.xAxis.gridLines.zeroLineWidth) : 1
                        });

                        if (config.axis.xAxis.gridLines.color) {
                            gridLines.color = config.axis.xAxis.gridLines.color;
                        }
                        if (config.axis.xAxis.gridLines.zeroLineColor) {
                            gridLines.zeroLineColor = config.axis.xAxis.gridLines.zeroLineColor;
                        }
                    } else {
                        gridLines = { display: false };
                    }

                    // Ticks config for xAxis
                    // At this moment this option is not editable in xAxis beyond if is enabled or disabled
                    if (config.axis.xAxis.ticks && config.axis.xAxis.ticks.show) {
                        ticks = {
                            display: config.axis.xAxis.ticks.show,
                            beginAtZero: config.axis.xAxis.ticks.beginAtZero === null || config.axis.xAxis.ticks.beginAtZero === undefined ?
                                true : config.axis.xAxis.ticks.beginAtZero,
                            autoSkip: true,
                            maxTicksLimit: 25
                        };

                        // Custom callback to show config.axis.xAxis ticks with the given numeral format
                        // If there is no numeral format in config.axis.xAxis config, callback is ignored
                        if (config.axis.xAxis.format) {
                            ticks.callback = (value, index, values) => {
                                return numeral(value).format(config.axis.xAxis.format);
                            };
                        }

                        // if custom is true, set the min, max and stepsize from config
                        if (config.axis.xAxis.ticks.custom) {
                            if (config.axis.xAxis.ticks.min) {
                                Object.assign(ticks, { min: Number(config.axis.xAxis.ticks.min) });
                            }
                            if (config.axis.xAxis.ticks.max) {
                                Object.assign(ticks, { max: Number(config.axis.xAxis.ticks.max) });
                            }
                            if (config.axis.xAxis.ticks.stepSize) {
                                Object.assign(ticks, { stepSize: Number(config.axis.xAxis.ticks.stepSize) });
                            }
                        }
                    } else {
                        ticks = { display: false };
                    }

                    xAxis = {
                        gridLines: gridLines,
                        ticks: ticks,
                        id: config.axis.xAxis.id,
                        position: config.axis.xAxis.position || 'left',
                        type: 'category',
                        stacked: chart.value === 'stackedHorizontalBar'
                    };
                    if (config.axis.xAxis.axisLabel && config.axis.xAxis.axisLabel.show) {
                        xAxis.scaleLabel = {
                            display: config.axis.xAxis.axisLabel.show,
                            labelString: config.axis.xAxis.axisLabel.label || ''
                        };
                    }

                    options.scales.yAxes.push(xAxis);
                } else {
                    options.scales.yAxes = [{
                        gridLines: { display: false },
                        ticks: { autoSkip: true },
                        stacked: chart.value === 'stackedHorizontalBar'
                    }];
                }
                if (config.axis.yAxis) {
                    if (config.axis.yAxis.sideA && config.axis.yAxis.sideA.length > 0) {
                        config.axis.yAxis.sideA.forEach(axe => {
                            let yAxis, gridLines = {}, ticks = {};

                            // GridLines config for yAxis
                            if (axe.gridLines && axe.gridLines.show) {
                                gridLines = {
                                    display: axe.gridLines.show || false,
                                    drawBorder: true /*axe.gridLines.border || false*/
                                };
                                Object.assign(gridLines, {
                                    borderDash: axe.gridLines.lineDash || [],
                                    borderDashOffset: Number(axe.gridLines.lineDashOffset || 0),
                                    lineWidth: axe.gridLines.lineWidth ? Number(axe.gridLines.lineWidth) : 1,
                                    zeroLineBorderDash: axe.gridLines.zeroLineDash || [],
                                    zeroLineBorderDashOffset: Number(axe.gridLines.zeroLineDashOffset || 0),
                                    zeroLineWidth: axe.gridLines.zeroLineWidth ? Number(axe.gridLines.zeroLineWidth) : 1,
                                });
                                if (axe.gridLines.color) {
                                    gridLines.color = axe.gridLines.color;
                                }
                                if (axe.gridLines.zeroLineColor) {
                                    gridLines.zeroLineColor = axe.gridLines.zeroLineColor;
                                }
                            } else {
                                gridLines = { display: false };
                            }

                            // Ticks config for yAxis
                            if (axe.ticks && axe.ticks.show) {
                                ticks = {
                                    display: axe.ticks.show,
                                    beginAtZero: axe.ticks.beginAtZero === null || axe.ticks.beginAtZero === undefined ?
                                        true : axe.ticks.beginAtZero,
                                    maxTicksLimit: 25
                                };

                                // Custom callback to show axe ticks with the given numeral format
                                // If there is no numeral format in axe config, callback is ignored
                                if (axe.format) {
                                    ticks.callback = (value, index, values) => {
                                        return numeral(value).format(axe.format);
                                    };
                                }

                                // if custom is true, set the min, max and stepsize from config
                                if (axe.ticks.custom) {
                                    if (axe.ticks.min) {
                                        Object.assign(ticks, { min: Number(axe.ticks.min) });
                                    }
                                    if (axe.ticks.max) {
                                        Object.assign(ticks, { max: Number(axe.ticks.max) });
                                    }
                                    if (axe.ticks.stepSize) {
                                        Object.assign(ticks, { stepSize: Number(axe.ticks.stepSize) });
                                    }
                                }

                                if (axe.ticks.direction && chart.orientation === 'horizontal') {
                                    ticks.autoSkip = true;
                                    switch (axe.ticks.direction) {
                                        case 'horizontal':
                                            ticks.minRotation = 0;
                                            ticks.maxRotation = 0;
                                            break;
                                        case 'vertical':
                                            ticks.minRotation = 90;
                                            ticks.maxRotation = 90;
                                            break;
                                        case 'slanting':
                                            ticks.minRotation = 45;
                                            ticks.maxRotation = 45;
                                            break;
                                        default:
                                            break;
                                    }
                                }

                            } else {
                                ticks = { display: false };
                            }

                            // Put all together before push into the axes array in options
                            yAxis = {
                                id: axe.id,
                                position: 'top',
                                gridLines: gridLines,
                                ticks: ticks,
                                stacked: chart.value === 'stackedHorizontalBar',
                                type: axe.scaleType || 'linear'
                            };

                            // TODO: scaleLabels from axisLabel with custom style options
                            if (axe.axisLabel && axe.axisLabel.show) {
                                yAxis.scaleLabel = {
                                    display: axe.axisLabel.show,
                                    labelString: axe.axisLabel.label || ''
                                };
                            }
                            options.scales.xAxes.push(yAxis);
                        });
                    }
                    if (config.axis.yAxis.sideB && config.axis.yAxis.sideB.length > 0) {
                        config.axis.yAxis.sideB.forEach(axe => {
                            let yAxis, gridLines = {}, ticks = {};

                            // GridLines config for yAxis
                            if (axe.gridLines && axe.gridLines.show) {
                                gridLines = {
                                    display: axe.gridLines.show || false,
                                    drawBorder: true /*axe.gridLines.border || false*/
                                };
                                Object.assign(gridLines, {
                                    borderDash: axe.gridLines.lineDash || [],
                                    borderDashOffset: Number(axe.gridLines.lineDashOffset || 0),
                                    lineWidth: axe.gridLines.lineWidth ? Number(axe.gridLines.lineWidth) : 1,
                                    zeroLineBorderDash: axe.gridLines.zeroLineDash || [],
                                    zeroLineBorderDashOffset: Number(axe.gridLines.zeroLineDashOffset || 0),
                                    zeroLineWidth: axe.gridLines.zeroLineWidth ? Number(axe.gridLines.zeroLineWidth) : 1,
                                });
                                if (axe.gridLines.color) {
                                    gridLines.color = axe.gridLines.color;
                                }
                                if (axe.gridLines.zeroLineColor) {
                                    gridLines.zeroLineColor = axe.gridLines.zeroLineColor;
                                }
                            } else {
                                gridLines = { display: false };
                            }

                            // Ticks config for yAxis
                            if (axe.ticks && axe.ticks.show) {
                                ticks = {
                                    display: axe.ticks.show,
                                    beginAtZero: axe.ticks.beginAtZero === null || axe.ticks.beginAtZero === undefined ?
                                        true : axe.ticks.beginAtZero,
                                    maxTicksLimit: 25
                                };

                                // Custom callback to show axe ticks with the given numeral format
                                // If there is no numeral format in axe config, callback is ignored
                                if (axe.format) {
                                    ticks.callback = (value, index, values) => {
                                        return numeral(value).format(axe.format);
                                    };
                                }

                                // if custom is true, set the min, max and stepsize from config
                                if (axe.ticks.custom) {
                                    if (axe.ticks.min) {
                                        Object.assign(ticks, { min: Number(axe.ticks.min) });
                                    }
                                    if (axe.ticks.max) {
                                        Object.assign(ticks, { max: Number(axe.ticks.max) });
                                    }
                                    if (axe.ticks.stepSize) {
                                        Object.assign(ticks, { stepSize: Number(axe.ticks.stepSize) });
                                    }
                                }

                                if (axe.ticks.direction && chart.orientation === 'horizontal') {
                                    ticks.autoSkip = true;
                                    switch (axe.ticks.direction) {
                                        case 'horizontal':
                                            ticks.minRotation = 0;
                                            ticks.maxRotation = 0;
                                            break;
                                        case 'vertical':
                                            ticks.minRotation = 90;
                                            ticks.maxRotation = 90;
                                            break;
                                        case 'slanting':
                                            ticks.minRotation = 45;
                                            ticks.maxRotation = 45;
                                            break;
                                        default:
                                            break;
                                    }
                                }

                            } else {
                                ticks = { display: false };
                            }

                            // Put all together before push into the axes array in options
                            yAxis = {
                                id: axe.id,
                                position: 'bottom',
                                gridLines: gridLines,
                                ticks: ticks,
                                stacked: chart.value === 'stackedHorizontalBar',
                                type: axe.scaleType || 'linear'
                            };

                            // TODO: scaleLabels from axisLabel with custom style options
                            if (axe.axisLabel && axe.axisLabel.show) {
                                yAxis.scaleLabel = {
                                    display: axe.axisLabel.show,
                                    labelString: axe.axisLabel.label || ''
                                };
                            }
                            options.scales.xAxes.push(yAxis);
                        });
                    }
                }
            }
            break;
        case 'radar':

            // Legend onClick Mod for hide the axis if there is no metric visible
            if (options.legend && options.legend.display) {
                options.legend.onClick = function(e, legendItem) {
                    let ci = this.chart, meta = ci.getDatasetMeta(legendItem.datasetIndex),
                        scale = ci.config.options.scale, metaDataset;

                    // See controller.isDatasetVisible comment
                    meta.hidden = meta.hidden === null ? !ci.data.datasets[legendItem.datasetIndex].hidden : null;
                    scale.display = !meta.hidden;
                    ci.config.data.datasets.forEach((ds, index) => {
                        if (index !== legendItem.datasetIndex) {
                            metaDataset = ci.getDatasetMeta(index);
                            if (metaDataset.hidden === null) { scale.display = true; }
                        }
                    });

                    // We hid a dataset ... rerender the chart
                    ci.update();
                }
            }

            options.scale = {};

            if (config.axis && config.axis.xAxis) {
                let axe;
                let gridLines = {};
                let ticks = {};

                // GridLines config for xAxis
                if (config.axis.xAxis.gridLines && config.axis.xAxis.gridLines.show) {
                    gridLines = {
                        display: config.axis.xAxis.gridLines.show || false,
                        drawBorder: true /*config.axis.xAxis.gridLines.border || false*/
                    };
                    Object.assign(gridLines, {
                        borderDash: config.axis.xAxis.gridLines.lineDash || [],
                        borderDashOffset: Number(config.axis.xAxis.gridLines.lineDashOffset || 0),
                        lineWidth: config.axis.xAxis.gridLines.lineWidth ? Number(config.axis.xAxis.gridLines.lineWidth) : 1,
                        zeroLineBorderDash: config.axis.xAxis.gridLines.zeroLineDash || [],
                        zeroLineBorderDashOffset: Number(config.axis.xAxis.gridLines.zeroLineDashOffset || 0),
                        zeroLineWidth: config.axis.xAxis.gridLines.zeroLineWidth ? Number(config.axis.xAxis.gridLines.zeroLineWidth) : 1
                    });

                    if (config.axis.xAxis.gridLines.color) {
                        gridLines.color = config.axis.xAxis.gridLines.color;
                    }
                    if (config.axis.xAxis.gridLines.zeroLineColor) {
                        gridLines.zeroLineColor = config.axis.xAxis.gridLines.zeroLineColor;
                    }
                } else {
                    gridLines = { display: false };
                }

                // Ticks config for axis
                // At this moment this option is not editable in axis beyond if is enabled or disabled
                if (config.axis.xAxis.ticks && config.axis.xAxis.ticks.show) {
                    ticks = {
                        display: config.axis.xAxis.ticks.show,
                        beginAtZero: config.axis.xAxis.ticks.beginAtZero === null || config.axis.xAxis.ticks.beginAtZero === undefined ?
                            true : config.axis.xAxis.ticks.beginAtZero,
                        autoSkip: true,
                        maxTicksLimit: 11
                    };
                } else {
                    ticks = { display: false };
                }

                axe = {
                    gridLines: gridLines,
                    ticks: ticks,
                };
                options.scale = cloneDeep(axe);
            }
            break;
        default:
            break;
    }

    return options;
}
/**
 * Insert plugin configuration into chartJS options object
 * @param chartData, data array with both metrics and dimension values
 * @param chartConfig, chart config object given by props to ChartComponent
 * @param chartOptions, chart chartOptions object previously generated by calculateOptions
 * @param instance, chart instance created in ChartComponent
 * @returns * chartOptions object updated with plugins config
 */

export function insertPluginsOptions(chartData, chartConfig, chartOptions, instance) {
    let data, { plugins } = chartConfig.graph, options = Object.assign({}, chartOptions);
    if (Immutable.Iterable.isIterable(chartData)) {
        data = chartData.toJS();
    } else {
        data = cloneDeep(chartData);
    }
    plugins.forEach(plugin => {
        switch(plugin.name) {
            case 'zoom':
                if (plugin.config.zoom && plugin.config.zoom.enabled) {
                    options.zoom = plugin.config.zoom;
                } else {
                    options.zoom = {enabled: false};
                }
                if (plugin.config.pan && plugin.config.pan.enabled) {
                    options.pan = plugin.config.pan;
                } else {
                    options.pan = {enabled: false};
                }
                break;
            case 'annotation':
                if (plugin.config.enabled) {
                    options = calculateAnnotations(data, chartConfig, chartOptions, instance);
                }
                break;
            default:
                break;
        }
    });
    return options;
}
/**
 * Calculate annotations arrays based on datasets and xAxis labels info
 * @param chartData, data array with both metrics and dimension values
 * @param chartConfig, chart config object given by props to ChartComponent
 * @param chartOptions, chart options object previously generated by calculateOptions
 * @param instance, chart instance created in ChartComponent
 * @return * options with the annotation plugins config and all calculated annotations
 * */
export function calculateAnnotations(chartData, chartConfig, chartOptions, instance) {
    let options = Object.assign({}, chartOptions), yAxisId,
        annotations = [], { dimension, metrics } = chartConfig.data,
        orderedData, years = [];

    let orderCriteria = { fields: [], criteria: [] };
    metrics.forEach(metric => {
        if (!!metric && !!metric.order && metric.order !== 'default') {
            orderCriteria.fields.push(metric.field);
            orderCriteria.criteria.push(metric.order);
        }
    });
    if (orderCriteria.fields.length > 0 && orderCriteria.criteria.length > 0) {
        orderedData = orderBy(chartData, orderCriteria.fields, orderCriteria.criteria);
    } else if (dimension && dimension.field){
        orderedData = orderBy(chartData, dimension.field);
    } else {
        orderedData = cloneDeep(chartData);
    }

    // if (dimension && dimension.field) {
    //     orderedData = orderBy(chartData, dimension.field);
    // } else {
    //     orderedData = cloneDeep(chartData);
    // }
    if (chartConfig.yAxis.leftAxis && chartConfig.yAxis.leftAxis.length > 0) {
        yAxisId = chartConfig.yAxis.leftAxis[0].id.toString();
    } else if (chartConfig.yAxis.rightAxis && chartConfig.yAxis.rightAxis.length > 0) {
        yAxisId = chartConfig.yAxis.rightAxis[0].id.toString();
    }
    if (dimension.dataType === 'date') {

        // Data Map to put the line annotations with label and get the data to draw the boxes
        orderedData.forEach((d, index) => {
            let annotationTemp;
            if (!find(years, {year: moment(d[dimension.field], dimension.format).get('year').toString()})) {
                years.push({
                    year: moment(d[dimension.field], dimension.format).get('year').toString(),
                    xMin: instance.config.data.labels[index],
                    yMin: instance.scales[yAxisId].start,
                    yMax: instance.scales[yAxisId].end
                });
                annotationTemp = {
                    id: `a-line-${index}`,
                    type: 'line',
                    mode: 'vertical',
                    scaleID: 'x-axis-0',
                    borderColor: 'transparent',
                    borderWidth: 2,
                    value: instance.config.data.labels[index],
                    label: {
                        backgroundColor: 'transparent',
                        fontColor: 'rgba(0, 0, 0, 0.6)',
                        content: moment(d[dimension.field], dimension.format).get('year').toString(),
                        fontSize: 20,
                        enabled: true,
                        position: 'top',
                        xAdjust: -35,
                        yAdjust: 10
                    }
                };
                annotations.push(annotationTemp);
            }
        });

        // Boxes annotations config With previous compiled data
        if (years.length > 0) {
            years = years.reverse();
            years.forEach((year, index) => {
                let annotationTemp = {
                    id: `a-box-${index}`,
                    type: 'box',
                    xScaleID: 'x-axis-0',
                    yScaleId: yAxisId,
                    xMin: year.xMin,
                    yMin: year.yMin,
                    yMax: year.yMax,
                    borderColor: 'transparent',
                    borderWidth: 1,
                    backgroundColor: `rgba(0, 0, 0, ${0.00 + (index * 0.03)})`
                };
                if (index === 0) {
                    annotationTemp.xMax = instance.data.labels[instance.data.labels.length - 1];
                } else {
                    annotationTemp.xMax = years[index - 1].xMin;
                }
                annotations.push(annotationTemp);
            });
        }
    }

    options.annotation = {
        drawTime: 'afterDatasetsDraw',
        events: [],
        annotations: annotations
    };
    return options;
}
/**
 * Validate all config structure based on the chart type from catalog
 * @param graph
 * @param dimension
 * @param metrics
 * @param xAxis
 * @param yAxis
 * @return boolean
 */
export function validateConfig(graph, dimension, metrics, xAxis, yAxis) {
    let valid = true;
    if (isArray(metrics) && metrics.length === 0) {
        return false;
    } else if (isEmpty(metrics)) { return false; }
    if (isEmpty(dimension)) { return false; }
    switch(graph.type) {
        case 'pie':
        case 'doughnut':
            break;
        case 'mixed':
            if (isArray(metrics)) {
                metrics.forEach(metric => {
                    if (metric.type !== 'line' && metric.type !== 'bar') { valid = false; }
                });
            } else if (metrics.type !== 'line' && metrics.type !== 'bar') { valid = false; }

            if (!xAxis || (xAxis &&  xAxis.length < 1)) { valid = false; }
            if (!yAxis) {
                valid = false;
            } else {
                valid = yAxis.length > 0;
            }
            break;
        case 'line':
        case 'area':
            if (isArray(metrics)) {
                metrics.forEach(metric => {
                    if (metric.type !== 'line') { valid = false; }
                });
            } else if (metrics.type !== 'line') { valid = false; }

            if (!xAxis || (xAxis &&  xAxis.length < 1)) { valid = false; }
            if (!yAxis) {
                valid = false;
            } else {
                valid = yAxis.length > 0;
            }
            break;
        case 'bar':
        case 'stackedBar':
            if (isArray(metrics)) {
                metrics.forEach(metric => {
                    if (metric.type !== 'bar') { valid = false; }
                });
            } else if (metrics.type !== 'bar') { valid = false; }

            if (!xAxis || (xAxis &&  xAxis.length < 1)) { valid = false; }
            if (!yAxis) {
                valid = false;
            } else {
                valid = yAxis.length > 0;
            }
            if (graph.type === 'stackedBar') {
                valid = yAxis.length === 1;
            }
            break;
        case 'horizontalBar':
        case 'stackedHorizontalBar':
            if (!yAxis) {
                valid = false;
            } else {
                valid = yAxis.length > 0;
            }
            if (!xAxis) {
                valid = false;
            } else {
                valid = xAxis.length > 0;
            }
            if (graph.type === 'stackedHorizontalBar') {
                valid = xAxis.length === 1;
            }
            break;
        case 'radar':
            break;
        default:
            break;
    }
    return valid;
}

function getTextMeasures(text, fontSize) {
    let canvas = getTextMeasures.canvas || (getTextMeasures.canvas = document.createElement("canvas"));
    let context = canvas.getContext("2d");
    // context.font = font;
    let metrics = context.measureText(text);
    return { width: metrics.width, height: fontSize || 12 };
}

export default {
    chartColorPalette,
    chartFamilies,
    chartCatalog,
    ticksDirection,
    calculateDatasets,
    calculateOptions,
    calculateAnnotations,
    insertPluginsOptions,
    getChartFamily,
    getChartFromCatalog,
    getChartType,
    validateConfig
};


// WEBPACK FOOTER //
// ./src/lib/chartjs-lib.js